import '../icon/index.js';

import {html, nothing} from 'lit';
import {when} from 'lit/directives/when.js';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {classMap} from 'lit/directives/class-map.js';

export const ANNOUNCEMENT_ELEMENT_TAG = 'fly-announcement';

/**
 * Possible intent varients for announcement components.
 */
export enum AnnouncementIntent {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

/**
 * Announcement -- Description here
 */
@customElement(ANNOUNCEMENT_ELEMENT_TAG)
export default class Announcement extends FlywheelComponent {
  @property()
  intent: AnnouncementIntent = AnnouncementIntent.PRIMARY;

  @property()
  label = '';

  @property({type: Boolean})
  hidden = false;

  @property({type: Boolean})
  fixed = false;

  static get styles() {
    return [styles];
  }

  get classes(): unknown {
    return classMap({
      'fly-announcement--primary': this.intent === AnnouncementIntent.PRIMARY,
      'fly-announcement--secondary':
        this.intent === AnnouncementIntent.SECONDARY,
      'fly-announcement--success': this.intent === AnnouncementIntent.SUCCESS,
      'fly-announcement--warning': this.intent === AnnouncementIntent.WARNING,
      'fly-announcement--danger': this.intent === AnnouncementIntent.DANGER,
      'fly-announcement--hidden': this.hidden,
    });
  }

  render() {
    return html`
      <div class="fly-announcement ${this.classes}">
        <div class="fly-announcement__content">
          <div class="fly-announcement__content__info">
            ${this.label
              ? html`<div class="fly-announcement__content__title">
                  ${this.label}
                </div>`
              : ''}
            <slot></slot>
          </div>
        </div>
        ${when(
          this.fixed,
          () => nothing,
          () => html`
            <fly-icon
              icon="close"
              class="fly-announcement__icon"
              @click=${() => (this.hidden = true)}
            >
            </fly-icon>
          `
        )}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fly-announcement': Announcement;
  }
}
